import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'isTodayUseApp',
      type: 'select',
      label: '当天登录App',
      clearable: true,
      placeholder: '请选择是、否',
      options: [
        { title: '是', value: 1 },
        { title: '否', value: 0 }
      ]
    },
    {
      field: 'isTodayUsePc',
      type: 'select',
      label: '当天登录Pc',
      clearable: true,
      placeholder: '请选择是、否',
      options: [
        { title: '是', value: 1 },
        { title: '否', value: 0 }
      ]
    },
    {
      field: 'userAccount',
      type: 'input',
      label: '客户账号',
      clearable: true,
      placeholder: '请输入客户账号'
    },
    {
      field: 'userName',
      type: 'input',
      label: '客户名称',
      clearable: true,
      placeholder: '请输入客户名称'
    },
    {
      field: 'assistant',
      type: 'input',
      label: '助手',
      clearable: true,
      placeholder: '请输入助手名称'
    },
    {
      field: 'manager',
      type: 'input',
      label: '助手经理',
      clearable: true,
      placeholder: '请输入助手经理名称'
    },
  ]
}
